import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=3fe8b951&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=ts&"
export * from "./policy.vue?vue&type=script&lang=ts&"
import style0 from "./policy.vue?vue&type=style&index=0&id=3fe8b951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8b951",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
